
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M437.018 74.987c-99.968-99.977-262.067-99.977-362.035 0-99.977 99.959-99.977 262.059 0 362.027 99.968 99.977 262.067 99.977 362.035 0 99.976-99.96 99.976-262.059 0-362.027zm-18.1 343.927c-89.984 89.967-235.853 89.967-325.837 0-89.967-89.975-89.967-235.844 0-325.828 89.984-89.967 235.853-89.967 325.837 0 89.967 89.984 89.967 235.853 0 325.828z"}}),_c('path',{attrs:{"d":"M274.099 256.004l81.459-81.459c5.001-4.992 5.001-13.107 0-18.099-4.992-5-13.107-5-18.099 0L256 237.905l-81.459-81.459c-4.992-5.009-13.107-5.009-18.099 0-5 4.992-5 13.107 0 18.099l81.459 81.459-81.459 81.459c-5 4.992-5 13.107 0 18.099 4.992 5.001 13.107 5.001 18.099 0L256 274.103l81.459 81.459c4.992 5 13.107 5 18.099 0 5.001-4.992 5.001-13.107 0-18.099l-81.459-81.459z"}})])
          )
        }
      }
    